import React from 'react';
import { Button, Header, Icon, Popup, Table } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FormattedMessage } from 'react-intl';

const NoExamTerms = () => <p><br />Nema ispitnih rokova.</p>;

export default class ActiveExamTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>

                {this.props.data.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Naziv ispitnog roka</Table.HeaderCell>
                                <Table.HeaderCell>Datum početka ispitnog roka</Table.HeaderCell>
                                <Table.HeaderCell>Datum kraja ispitnog roka</Table.HeaderCell>
                                <Table.HeaderCell>
                                    <Header as="h4" image>
                                        <Header.Content>
                                            Početak prijave ispita
                                            <Header.Subheader>(datum/broj dana prije ispita)</Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                </Table.HeaderCell>
                                <Table.HeaderCell>
                                    <Header as="h4" image>
                                        <Header.Content>
                                            Kraj prijave ispita
                                            <Header.Subheader>(broj dana prije ispita)</Header.Subheader>
                                        </Header.Content>
                                    </Header>
                                </Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.props.data.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle" width={1}>
                                        {(index + 1)}.
                                    </Table.Cell >
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {el.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.startDatee}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.endDatee}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.registrationOpeningDays ? el.registrationOpeningDays : el.registrationOpeningDate ? moment(el.registrationOpeningDate).format('D. M. YYYY.') : ''}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.registrationClosing}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell textAlign="center" verticalAlign="middle">

                                        <Popup
                                            content="Ispiti"
                                            position="top center"
                                            trigger={
                                                <Link to={{ pathname: '/ispitni-rokovi/ispiti', state: { id: el.id, name: el.name } }}>
                                                    <Button
                                                        basic
                                                        circular
                                                        icon="copy outline"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => {
                                                            localStorage.removeItem('examsFilters'); // Resetovanje filtera za ispite
                                                        }}
                                                    />
                                                </Link>}
                                        />
                                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Link to={{
                                                    pathname: '/ispitni-rokovi/izmjena',
                                                    state: { exam: el }
                                                }}
                                                ><Button
                                                        basic
                                                        circular
                                                        icon="pencil"
                                                        size="small"
                                                        color="green"
                                                />
                                                </Link>}
                                        />}
                                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Popup
                                            content="Obriši rok"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={this.props.deleting && el.id !== this.state.currentId}
                                                    onClick={() => { this.setState({ currentId: el.id }); this.props.deleteExamTerm(el.id); }}
                                                    basic
                                                    circular
                                                    icon="trash alternate"
                                                    size="small"
                                                    color="red"
                                                />
                                            }
                                        />}


                                    </Table.Cell>
                                </Table.Row>))
                            }
                        </Table.Body>
                    </Table>
                    : <NoExamTerms />
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/ExamTerms/ActiveExamTerms.js